module.exports = __webpack_public_path__ + "static/media/bus-school.1e052a18.svg";